import { PROVIDER_USER_TYPE } from './ddgConstants';

export const canCreateListing = (user) => user?.attributes?.profile?.publicData?.userType === PROVIDER_USER_TYPE;

export const isConnectedToPayPal = (user) => user?.attributes?.profile?.publicData?.merchantId && user?.attributes?.profile?.publicData?.merchantIdInPayPal;

export const getPayPalSignupLinkPayload = (returnUrl) => {
   const trackingId = crypto.randomUUID().toString();
   return {
      // TODO: we can probably add merchant metadata here to prefill some business details but not right now
      tracking_id: trackingId,
      "operations": [{
        "operation": "API_INTEGRATION",
        "api_integration_preference": {
          "rest_api_integration": {
            "integration_method": "PAYPAL",
            "integration_type": "THIRD_PARTY",
            "third_party_details": {
              "features": [
                "PAYMENT",
                "REFUND",
                "PARTNER_FEE"
              ]
            }
          }
        }
      }],
      "products": [
        "EXPRESS_CHECKOUT"
      ],
      "legal_consents": [{
        "type": "SHARE_DATA_CONSENT",
        "granted": true
      }],
      "partner_config_override": {
         "return_url": returnUrl
      }
   }
};
